export default __webpack_public_path__ + "b536ab4.png";